import { render, staticRenderFns } from "./CosmetRegistrationConfig.vue?vue&type=template&id=1febe0f0&scoped=true&"
import script from "./CosmetRegistrationConfig.vue?vue&type=script&lang=js&"
export * from "./CosmetRegistrationConfig.vue?vue&type=script&lang=js&"
import style0 from "./CosmetRegistrationConfig.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CosmetRegistrationConfig.vue?vue&type=style&index=1&id=1febe0f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1febe0f0",
  null
  
)

export default component.exports